import type {
  CalendarProviderIntegration,
  MicrosoftAccountKind,
  UserProvider,
  UserProviderAccount,
  UserCalendarIntegrationResponse,
} from "@kontextwerk/control-web-client"
import type { UserCalendarIntegrationOperations } from "../../../contract"

export const setupSteps = [
  "connect_account",
  "select_write_target",
  "select_read_sources",
  "summary",
] as const
export type CalendarSetupStep = (typeof setupSteps)[number]
export type CalendarSetupScope = {
  organizationId: string
  userId: string
  provider: UserProvider
  providerAccountId: string
  operations: UserCalendarIntegrationOperations
}
export type CalendarSetupCopy = {
  productName: string
  writeTargetLabel: string
  managedCalendarName: string
}
export type CalendarSetupProps = {
  scope: CalendarSetupScope
  account: UserProviderAccount | null
  integration: CalendarProviderIntegration | null
  copy: CalendarSetupCopy
  requestedStep?: CalendarSetupStep | null
  canAuthorize: boolean
  authorize: (kind?: MicrosoftAccountKind | null, returnPath?: string | null) => Promise<void>
  oauthReturnPath?: string | null
  onUpdated: (overview: UserCalendarIntegrationResponse) => void
  registerCloseGuard: (guard: () => Promise<boolean>) => void
  onshowOverlay?: (() => void) | null
  onremoveOverlay?: (() => void) | null
}
